module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-panrb.032bb4a4.png";